import _ from 'lodash';
import { connect } from 'react-redux';

import { Profile } from '@zapier/shared-entities';
import * as Subscription from 'app/entities/Subscription';
import * as UserNotification from 'app/entities/UserNotification';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import NotificationsMenu from 'app/viewport/components/NotificationsMenu';
import TrackActions from 'app/track/TrackActions';
import ViewportActions from 'app/viewport/ViewportActions';
import hocify from 'app/common/components/hocify';
import { isNotificationsDropdownOpen } from 'app/viewport/Selectors';
import {
  isNew,
  maybeDismissStaticNotification,
  sortNotifications,
} from 'app/viewport/utils/notification';

const mapStateToProps = state => {
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const notificationEntities = UserNotification.selectors.all.notDismissed(
    state
  );
  const notifications = sortNotifications(
    _.map(notificationEntities, entity =>
      UserNotification.selectors.data(entity)
    )
  );

  return {
    profile: Profile.selectors.data(currentProfile),
    isLoading:
      UserNotification.selectors.all.isLoadImpending(state) ||
      Profile.selectors.all.isLoadImpending(state) ||
      Subscription.selectors.all.isLoadImpending(state),
    notifications,
    isDropdownOpen: isNotificationsDropdownOpen(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoad() {
      dispatch(Subscription.actions.loadCollection());
      dispatch(Profile.actions.loadCollection()).then(() => {
        // UserNotification loadCollection depends on current profile already being loaded
        dispatch(UserNotification.actions.loadCollection());
      });
    },
    onNotificationsRead(notifications) {
      dispatch(ViewportActions.markNotificationsRead(notifications));
    },
    onNotificationCta(notification) {
      dispatch(ViewportActions.notificationCta(notification));
    },
    onNotificationsDelivered(notifications) {
      const undelivered = notifications.filter(n =>
        isNew(n.notificationStatus)
      );

      if (undelivered.length > 0) {
        dispatch(
          UserNotification.actions.markNotificationsDelivered(undelivered)
        );
        dispatch(
          TrackActions.track('in-app notification: notifications delivered')
        );
      }
    },
    onDismissNotification(notificationId) {
      maybeDismissStaticNotification(notificationId);
      dispatch(ViewportActions.dismissNotification(notificationId));
    },
    onToggleDropdown() {
      dispatch(ViewportActions.toggleNotificationsDropdown());
    },
  };
};

export default _.flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  hocify(LoadingBlockOrComponent)
)(NotificationsMenu);
